module.exports = __webpack_public_path__ + "static/media/svg-1.f43ca2d2.svg";